import { useNavigate } from "react-router-dom";
import {
  GoabGrid,
  GoabButton,
  GoabContainer,
  GoabSpacer,
  GoabDivider,
} from "@abgov/react-components";
import {
  USER_APPLICATION_SESSION_KEY,
  isPortalActive,
} from "../../MPP-Common-SPA/utils/globalUtility";

const NewApplicationListComponent = ({
  availableEvents = [],
  getResourceValue,
  program,
  user,
  applicationList = [],
  programEvents = [],
}) => {
  const navigate = useNavigate();

  const goToApply = (name) => {
    sessionStorage.removeItem(USER_APPLICATION_SESSION_KEY);
    navigate(`/apply/?type=event&hint=${name}`);
  };

  const goToApplyWithoutEvent = () => {
    sessionStorage.removeItem(USER_APPLICATION_SESSION_KEY);
    navigate(`/apply/`);
  };

  if (!isPortalActive(program, user) || user?.isProxyUser) {
    return null;
  }

  // If events are enabled but none available, show nothing
  if (availableEvents?.length === 0) {
    return null;
  }

  // If only one event is available and only one event exists, show a single "Start another application" button
  if (availableEvents?.length == 1 && programEvents.length == 1) {
    return (
      <>
        <GoabSpacer vSpacing="m" />
        <GoabButton type="primary" onClick={goToApplyWithoutEvent}>
          {applicationList.length > 0 ? (
            <>Start another application</>
          ) : (
            <>Start application</>
          )}
        </GoabButton>
      </>
    );
  }

  // Show event-based applications
  return (
    <>
      <GoabSpacer vSpacing="xl" />
      <GoabDivider />
      <GoabSpacer vSpacing="xl" />
      <h3>
        {getResourceValue({
          key: "RESOURCES@myApplications.openForApplications",
        })}
      </h3>
      <GoabSpacer vSpacing="l" />
      <GoabGrid key={availableEvents?.length} gap="l" minChildWidth="340px">
        {availableEvents.map(({ code, name }) => (
          <div key={code} id={code} style={{ width: "340px" }}>
            <GoabContainer>
              <h4>{name}</h4>
              <GoabSpacer vSpacing="m" />
              <GoabButton
                size="compact"
                type="primary"
                onClick={() => goToApply(code)}
              >
                {getResourceValue({ key: "RESOURCES@global.button.apply" })}
              </GoabButton>
            </GoabContainer>
          </div>
        ))}
      </GoabGrid>
    </>
  );
};

export default NewApplicationListComponent;
